import { createFileRoute, stripSearchParams } from '@tanstack/react-router'

import { TeamEditPage } from '@/features/org/components/team-form-page'
import { TEAMS_SEARCH_DEFAULTS, teamsSearchSchema } from '@/features/org/search-schema'

/**
 * /teams/$teamId/edit —— 改团队(改名 / 改上级)。
 * 无删除:Team 被 Employee.team PROTECT 引用,删不掉也不该删。
 */
export const Route = createFileRoute('/_authed/teams/$teamId/edit')({
  validateSearch: teamsSearchSchema,
  search: {
    middlewares: [stripSearchParams(TEAMS_SEARCH_DEFAULTS)],
  },
  component: TeamEditPage,
})
